/* Photo projection comes only from the back of a published BRRWare Cup Library profile.
 * This preview estimate never changes the separate 60 × 95 mm artwork board. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.GroomsmanProductCalibration = factory();
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  function rectangle(value, label) {
    if (!value || !['x', 'y', 'width', 'height'].every(key => Number.isFinite(value[key])) ||
        value.x < 0 || value.y < 0 || value.width <= 0 || value.height <= 0 ||
        value.x + value.width > 1.000001 || value.y + value.height > 1.000001) {
      throw new RangeError(label + ' must fit the normalized photo stage.');
    }
    return value;
  }
  function resolve(photo) {
    if (photo?.productId !== 'brrware' || photo.calibrationSource?.type !== 'published-cup-library' ||
        photo.side !== 'back' || photo.calibrationSource.side !== 'back') {
      throw new RangeError('Choose a published BRRWare back preview photo.');
    }
    rectangle(photo.crop, 'The photo crop'); rectangle(photo.stageCropRect, 'The photo frame');
    const region = { ...rectangle(photo.stageArea, 'The preview area') };
    if (![photo.widthMm, photo.heightMm].every(value => Number.isFinite(value) && value > 0)) {
      throw new RangeError('The product preview needs positive physical dimensions.');
    }
    return { region, physicalArea: { widthMm: photo.widthMm, heightMm: photo.heightMm },
      scaleX: region.width / photo.widthMm, scaleY: region.height / photo.heightMm,
      approximate: true, previewOnly: true };
  }
  return Object.freeze({ resolve });
});
